<h4 matDialogTitle>{{ title }}</h4>
<mat-dialog-content>
  <div class="flex flex-col justify-start items-stretch md:min-w-[450px] gap-y-2">
    @if (data.confirmInvoiceDetails) {
    <p>Before converting to an invoice, please confirm the details below.</p>
    @if (isDocketLockedAfterInvoice$ | async) {
    <app-alert-text type="warning" title="Warning"
      message="Once this contract has been converted to an invoice it will be locked, no further edits will be possible."></app-alert-text>
    }
    }
    @if (docketLocked$ | async) {
    <app-alert-text type="warning" title="Warning"
      message="This contract has been locked, no further edits will be possible."></app-alert-text>
    }

    <form [formGroup]="form">
      <div class="flex flex-col justify-start items-stretch">
        <mat-form-field>
          <input matInput formControlName="purchase_order" name="Purcahse order" placeholder="Purchase Order" />
        </mat-form-field>

        <mat-form-field>
          <mat-select mat-form-field-control placeholder="Tax Rate" name="Tax Rate" id="location" name="Tax rate"
            formControlName="tax_rate" required="true">
            <mat-option *ngFor="let rate of taxRates$ | async" [value]="rate.value">{{ rate.name }} - {{ rate.value |
              percent: '1.0-2' }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="flex flex-row items-center">
          <span class="basis-1/3 pr-4">Invoice Type:</span>
          <mat-radio-group class="example-radio-group" formControlName="account" class="flex flex-col basis-2/3"
            name="Invoice Type" [required]="true">
            <mat-radio-button class="example-radio-button" [value]="0" class="flex flex-row">
              Cash Invoice
            </mat-radio-button>
            <mat-radio-button class="example-radio-button" [value]="1" class="flex flex-row"
              [disabled]="!(hasAccount$ | async)">
              Account
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <span class="warn" *ngIf="isAccountCustomer$ | async">
          This customer does not have an account number.
        </span>
        <mat-form-field>
          <input matInput formControlName="rollover_date" name="Date" [matDatepicker]="picker"
            [disabled]="data.docket.rolled_over_to !== null" placeholder="Rollover date" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        </mat-form-field>
        <mat-datepicker #picker></mat-datepicker>
        @if (
        shouldShowRolloverWarning$ | async
        ) {
        <app-alert-text type="warning" title="Warning"
          message="This rollover date is in the past, the contract will be rolled over immediately after you press Save."></app-alert-text>
        }
        <ng-container *ngIf="currencies$ | async as currecies">
          <ng-container *ngIf="currecies.length > 1">
            <mat-form-field>
              <mat-select mat-form-field-control placeholder="Currency" name="Currency" id="currency" name="Currency"
                formControlName="currency_code" required="true">
                <mat-option *ngFor="let currency of currecies" [value]="currency">{{ currency }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Conversion rate</mat-label>
              <input matInput formControlName="currency_rate" name="Conversion rate" placeholder="Conversion rate"
                required="true" />
            </mat-form-field>
          </ng-container>
        </ng-container>
      </div>
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button (click)="dialogRef.close()">Cancel</button>
  <button mat-raised-button color="primary" (click)="submit()" [disabled]="!form.valid || submitting">
    Save
  </button>
</mat-dialog-actions>